// ---------------------------------------------------------------------------
// HRIS module — API endpoint constants
// ---------------------------------------------------------------------------
// Self-contained, like the Attendance module: the HRIS feature owns its own API
// surface. It targets the dedicated HRIS backend via HRIS_BASE_URL (separate
// host/port from the Digital Ghanti core service).
//
// Backend controller: @RequestMapping(API_V1 + "/hris/staff")
//   POST   /hris/staff          → create
//   PUT    /hris/staff/{id}     → update
//   GET    /hris/staff/{id}     → detail
//   GET    /hris/staff          → search (keyword, status, page, size) → Page
//   DELETE /hris/staff/{id}     → delete
// ---------------------------------------------------------------------------
import {HRIS_BASE_URL} from "../../../../constants/ApiConstant";

const HRIS = "/hris";
const STAFF = "/staff";
const ATTENDANCE = "/attendance";

export const hrisApiConstants = {
    STAFF_BASE: HRIS_BASE_URL.concat(HRIS).concat(STAFF),
    // Staff QR attendance base (kept for reference).
    STAFF_ATTENDANCE_BASE: HRIS_BASE_URL.concat(HRIS).concat(ATTENDANCE),
    // POST — staff punches in for the day.
    STAFF_ATTENDANCE_CHECK_IN: HRIS_BASE_URL.concat(HRIS).concat(ATTENDANCE).concat("/check-in"),
    // POST — staff punches out for the day.
    STAFF_ATTENDANCE_CHECK_OUT: HRIS_BASE_URL.concat(HRIS).concat(ATTENDANCE).concat("/check-out"),
};

// Staff attendance status posted from the QR check-in page.
export const STAFF_ATTENDANCE_STATUS = {
    PRESENT: "PRESENT",
    LATE: "LATE",
};

// The two actions a staff member can pick on the scan page.
export const ATTENDANCE_ACTION = {
    CHECK_IN: "CHECK_IN",
    CHECK_OUT: "CHECK_OUT",
};

export const ATTENDANCE_ACTION_META = {
    CHECK_IN: {label: "Check In", verb: "checked in"},
    CHECK_OUT: {label: "Check Out", verb: "checked out"},
};

// Business rule: mornings default to Check In, afternoons/evenings to Check Out.
// The cutoff is local noon (12:00). Returns an ATTENDANCE_ACTION value.
export function defaultAttendanceAction(now = new Date()) {
    return now.getHours() < 12 ? ATTENDANCE_ACTION.CHECK_IN : ATTENDANCE_ACTION.CHECK_OUT;
}

// Hash route (public, no auth) that the generated QR points to. Staff land here
// after scanning to submit their attendance.
export const STAFF_ATTENDANCE_CHECKIN_ROUTE = "/staff-attendance";

// Mirrors the backend StaffStatus enum. Adjust the keys here if the enum on the
// server uses different constants — the UI reads everything from this map.
export const STAFF_STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    ON_LEAVE: "ON_LEAVE",
    TERMINATED: "TERMINATED",
};

export const STAFF_STATUS_META = {
    ACTIVE: {label: "Active", color: "green"},
    INACTIVE: {label: "Inactive", color: "gray"},
    ON_LEAVE: {label: "On Leave", color: "orange"},
    TERMINATED: {label: "Terminated", color: "red"},
};

// Display order for the status filter dropdown.
export const STAFF_STATUS_ORDER = [
    STAFF_STATUS.ACTIVE,
    STAFF_STATUS.ON_LEAVE,
    STAFF_STATUS.INACTIVE,
    STAFF_STATUS.TERMINATED,
];
